<template>
  <div class="uploader">
    <div class="dropzone" :class="{ 'is-filled': value }" @click="pick">
      <div class="dropzone__icon">
        <LtIcon :name="value ? 'check' : 'upload'" :size="20" />
      </div>
      <div style="flex: 1; min-width: 0">
        <div class="dropzone__title">
          {{ value ? (value.name || 'הועלה בהצלחה') : title }}
          <span v-if="required && !value" style="color: var(--c-pink-500)">*</span>
        </div>
        <div class="dropzone__text">{{ value ? (value.size ? value.size + ' · הועלה בהצלחה' : 'הועלה בהצלחה') : hint }}</div>
      </div>
      <button v-if="value" type="button" class="dropzone__file" @click="remove">
        <span class="remove"><LtIcon name="close" :size="12" /></span>
      </button>
    </div>
  </div>
</template>

<script>
import LtIcon from './LtIcon.vue';
import { WIZARD_UPLOAD_KEY } from './wizardInject.js';

export default {
  name: 'Dropzone',
  components: { LtIcon },
  inject: {
    uploadFile: { from: WIZARD_UPLOAD_KEY, default: () => () => Promise.resolve(null) },
  },
  props: {
    value: { type: [Object, Number], default: null },
    title: { type: String, required: true },
    hint: { type: String, default: '' },
    accept: { type: String, default: '' },
    required: { type: Boolean, default: false },
  },
  data() {
    return { uploading: false };
  },
  emits: ['update:value'],
  methods: {
    pick() {
      const acceptMap = { pdf: '.pdf', doc: '.doc,.docx', docx: '.docx', mp3: '.mp3', wav: '.wav', mp2: '.mp2' };
      const acceptAttr = this.accept.split(',').map(a => acceptMap[a.trim()] || '.' + a.trim()).join(',');

      const input = document.createElement('input');
      input.type = 'file';
      input.accept = acceptAttr || '*/*';
      input.onchange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        this.uploading = true;
        this.uploadFile(file, this.accept).then((res) => {
          this.uploading = false;
          if (res) this.$emit('update:value', { storage_id: res.storage_id, name: res.name, size: res.size });
        }).catch(() => {
          this.uploading = false;
        });
      };
      input.click();
    },
    remove(e) {
      e.stopPropagation();
      this.$emit('update:value', null);
    },
  },
};
</script>
